import { render } from "./PersonalDetailSocials.vue?vue&type=template&id=77986e2b&scoped=true"
import script from "./PersonalDetailSocials.vue?vue&type=script&lang=js"
export * from "./PersonalDetailSocials.vue?vue&type=script&lang=js"

import "./PersonalDetailSocials.vue?vue&type=style&index=0&id=77986e2b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77986e2b"]])

export default __exports__